let subscribers = {};

function subscribe(eventName, callback) {
  if (subscribers[eventName] === undefined) {
    subscribers[eventName] = [];
  }

  subscribers[eventName] = [...subscribers[eventName], callback];

  return function unsubscribe() {
    subscribers[eventName] = subscribers[eventName].filter((cb) => {
      return cb !== callback;
    });
  };
}

function publish(eventName, data) {
  if (subscribers[eventName]) {
    subscribers[eventName].forEach((callback) => {
      // BPP: one faulty subscriber must not stop the others, or the publisher.
      // product-form publishes cartUpdate before it renders the cart drawer, so
      // an uncaught throw here used to leave the drawer empty after an add.
      try {
        callback(data);
      } catch (error) {
        console.error(`pubsub: a "${eventName}" subscriber threw`, error);
      }
    });
  }
}
